module.exports = __webpack_public_path__ + "media/theme/tutorial__itunes--5-bc7fadb0.png";